export default __webpack_public_path__ + "static/media/ESSC16XIAB01.200e99f8.mp4";